// extracted by mini-css-extract-plugin
export default {"actionsRow":"bank-accounts_actionsRow__BAnvI","noBanksText":"bank-accounts_noBanksText__H-J73","addButton":"bank-accounts_addButton__EV1IX"};